export const moduleSlug = "TRACKER";

export const EXPORT_RESULT_OBJECTS_OFFSET = 25;

export default { moduleSlug };
